import axios from '../utils/axios';

export default function fetchRecruiterId(adminId,params) {
    return (
        axios.get('/admin/'+adminId+'/recruiter',{
            params:params
        })
        .then(res => {
            return res.data
        })
        .catch(err => {
            return err;
        })
    )
}
